<template>
  <div class="du-versions">
    <div class="ver-cond panel-card">
      <el-form inline>
        <el-form-item :label="$str.getKey('设备升级/选择电站')">
          <el-select filterable v-model="stationId" @change="onStationIdChange">
            <el-option :value="s.stationId" :label="s.name" v-for="s in stations" :key="s.stationId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <versions-table :stationId="stationId" />
  </div>
</template>

<script setup>
import useAppStore from '@/store/modules/app'
import { ref, computed, watchEffect } from 'vue'
import VersionsTable from './versions-table.vue'
import { createStorage } from './feature'

const { save, load } = createStorage('localStorage')
const appStore = useAppStore()
const stationId = ref(load('upgrade-stationId', ''))
const stations = computed(() => {
  return appStore.stations
})

const $str = window.$str

function onStationIdChange(value) {
  save('upgrade-stationId', value)
}

watchEffect(() => {
  if (stations.value.length > 0 && !stationId.value) {
    stationId.value = stations.value[0].stationId
  }
})
</script>

<style lang='scss' src="./style.scss"></style>
